import React from "react"
import Body, { BodyProps } from "../../typography/Body"

type FormSubtitleProps = BodyProps & {}

export default function FormSubtitle({ ...props }: FormSubtitleProps) {
  return <Body size="md" color="dusk" {...props} />
}
